import { useNavigate } from "react-router-dom";
import { SignIn, SignOut, UserCircle } from "@phosphor-icons/react";
import { useAuth } from "@/contexts/AuthContext";
import PriceAlertBell from "@/components/PriceAlertBell";

export default function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (user === null) return null; // auth still loading

  if (!user) {
    return (
      <button
        onClick={() => navigate("/auth")}
        data-testid="nav-login-btn"
        className="flex items-center gap-1.5 text-[11px] text-zinc-400 hover:text-amber-300 transition-colors px-2.5 py-1.5 border border-zinc-800 hover:border-amber-500/40 rounded-sm shrink-0"
      >
        <SignIn size={13} weight="bold" />
        Sign In
      </button>
    );
  }

  return (
    <div className="flex items-center gap-2 shrink-0">
      <PriceAlertBell />
      <button
        onClick={() => navigate("/profile")}
        data-testid="nav-profile-btn"
        aria-label="Open profile"
        title={user.name || user.email}
        className="flex items-center gap-1 text-[10px] text-zinc-400 hover:text-amber-300 transition-colors px-1.5 py-1 rounded-sm"
      >
        <UserCircle size={18} weight="bold" className="text-amber-400" />
        <span className="hidden sm:inline max-w-[120px] truncate">{user.name || user.email}</span>
      </button>
      <button
        onClick={logout}
        data-testid="nav-logout-btn"
        className="text-[10px] text-zinc-500 hover:text-red-400 transition-colors px-2 py-1 border border-zinc-800 hover:border-red-800/50 rounded-sm"
      >
        <SignOut size={12} />
      </button>
    </div>
  );
}
